<template>
  <div v-if="items.length > 1" :style="`border-bottom: ${filterBorderBottomColor} 1px solid`" class="storefront-sidebar-filters-container mb-0 pb-0">
    <div class="storefront-sidebar-filters-title" @click="collapse">
      <h6 class="row m-0 align-items-center mb-0">
        <div style="width: 32px">
          <SidebarPriceIcon
            v-if="icon == 'price'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
        </div>
        <span :style="`color: ${titleColor}`">{{ title }}</span>
        <i :style="`color: ${itemTextColor}`" :class="`fa fas fa-angle-${collapsed ? 'up' : 'down'} ml-auto`" />
      </h6>
    </div>
    <b-collapse class="storefront-sidebar-filters" :visible="!collapsed">
      <ul class="nav flex-column">
        <li v-for="(item, i) in items" :key="i" :style="filterItemStyle(item)" class="nav-item">
          <SelectBox
            :label="item.label"
            :selected-color="selectedCheckboxColor"
            :not-selected-color="unSelectedCheckboxColor"
            :selected="item.selected"
            @on-selected="onSelect(item)"
          />
        </li>
      </ul>
      <a
        style="font-size: 12px; font-weight: 500"
        class="mt-3 mb-2 d-block text-primary"
        @click="() => (customPriceRangeVisible = customPriceRangeVisible ? false : true)"
      >
        <i v-if="customPriceRangeVisible" :style="`color: ${itemTextColor}`" class="fa fas fa-minus mr-1" />
        <i v-if="!customPriceRangeVisible" :style="`color: ${itemTextColor}`" class="fa fas fa-plus mr-1" />
        <span :style="`color: ${itemTextColor}`"> Custom Price Range </span>
      </a>
      <b-collapse class="" :visible="customPriceRangeVisible">
        <div class="d-flex align-items-start">
          <BushelTextInput
            v-model="priceMin"
            class="mr-1 col p-0"
            input-class="price-range-input"
            type="number"
            placeholder="Min Price"
            thin
            no-padding
            hide-label
          />
          <BushelTextInput
            v-model="priceMax"
            class="ml-1 col p-0"
            input-class="price-range-input"
            type="number"
            placeholder="Max Price"
            :min="Number(priceMin)"
            thin
            hide-label
          />
          <BushelBtn
            :disabled="!priceFilterBtnActive"
            :style="`
                            font-size: 13px;
                            height: 30px;
                            background-color: ${filterBtnBgColor};
                            color:${filterBtnColor}
                        `"
            class="p-0 px-2 ml-2"
            @click="filterPriceRange"
          >
            Filter
          </BushelBtn>
          <BushelBtn
            v-if="filtered"
            :disabled="!priceFilterBtnActive"
            :style="`
                            font-size: 13px;
                            height: 30px;
                            background-color: ${filterBtnBgColor};
                            color:${filterBtnColor}
                        `"
            class="p-0 px-2 ml-2"
            @click="clearFilterPriceRange"
          >
            Clear
          </BushelBtn>
        </div>
      </b-collapse>
    </b-collapse>
  </div>
</template>
<script>
import SidebarPriceIcon from "@/components/common/icons/SidebarPriceIcon.vue";
import SelectBox from "@/components/common/SelectBox.vue";
import BCollapse from "@/components/base/BCollapse.vue";

export default {
  components: {
    SelectBox,
    SidebarPriceIcon,
    BCollapse,
  },
  props: {
    title: { type: String, required: true },
    icon: { type: String },
    items: { type: [Object, Array], required: true },
    filterBorderBottomColor: { type: String },
    filterBtnBgColor: { type: String },
    filterBtnColor: { type: String },
    iconColor: { type: String },
    titleColor: { type: String },
    selectedCheckboxColor: { type: String },
    unSelectedCheckboxColor: { type: String },
    itemTextColor: { type: String },
    selectedTextColor: { type: String },
    category: { type: String },
  },
  emits: ["selected"],
  data() {
    return {
      collapsed: true,
      customPriceRangeVisible: true,
      priceMin: null,
      priceMax: null,
      filtered: false,
    };
  },
  computed: {
    priceFilterBtnActive() {
      if (!this.priceMin || !this.priceMax) {
        return false;
      }
      if (this.priceMin && this.priceMax && Number(this.priceMin) >= Number(this.priceMax)) {
        return false;
      }

      return true;
    },
  },
  methods: {
    collapse() {
      this.collapsed = !this.collapsed;
    },
    filterItemStyle(item) {
      if (item.selected) {
        return {
          color: this.selectedTextColor,
        };
      }
      return {
        color: this.itemTextColor,
      };
    },
    onSelect(item) {
      this.priceMin = null;
      this.priceMax = null;
      this.$emit("selected", item);
    },

    filterPriceRange() {
      this.filtered = true;
      this.$emit("selected", {
        label: "custom",
        value: [this.priceMin, this.priceMax],
        selected: true,
      });
    },
    clearFilterPriceRange() {
      this.filtered = false;
      this.priceMin = null;
      this.priceMax = null;
      this.$emit("selected", {
        label: "custom",
        value: [this.priceMin, this.priceMax],
        selected: false,
      });
    },
  },
};
</script>
